import { useTranslation } from "next-i18next";
import React from "react";

import { ProjectBudgetSection } from "./ProjectBudgetSection";
import ProjectServiceSection from "./ProjectServiceSection";

import type { ProjectEditProps } from "./ProjectEditProps";

export const AgreementProject = (props: ProjectEditProps) => {
	const { t } = useTranslation();

	return (
		<div>
			<div>
				<div className="hrTitle lightGreyFont paddingBottom40">
					<span className="left">{t("budget").toLocaleUpperCase()}</span>
					<hr className="right" />
				</div>
				<ProjectBudgetSection
					setErrors={props.setErrors}
					errors={props.errors}
					project={props.project}
					setProject={props.setProject}
				/>
			</div>
			<div>
				<div className="hrTitle lightGreyFont paddingBottom40">
					<span className="left">{t("services").toLocaleUpperCase()}</span>
					<hr className="right" />
				</div>
				<ProjectServiceSection setProject={props.setProject} project={props.project} />
			</div>
		</div>
	);
};

AgreementProject.displayName = "AgreementProject";
